import { createFileRoute } from '@tanstack/react-router'
import { JournalPage } from '#pages/client/JournalPage'

export const Route = createFileRoute('/_app/journal/$sessionId')({
  component: JournalPage,
})
